<template>
	<div class="model modal--alist modal-alist">
		<div class="modal-alist__header">
			<span class="modal-alist__tag">A-List</span>
			<h2 class="modal-alist__title">Exclusive Tools for A-List Banks</h2>
		</div>
		<div class="modal-alist__body">
			<h4>INCLUDED WITH A-LIST</h4>
			<div class="resource-list">
				<div class="resource-list__item" v-for="(item, index) in resources" :key="index">
					<div class="resource-list__item-graphic">
						<div class="resource-list__item-logo">
							<img :src="item.logo" v-if="item.logo" />
							<ion-icon :name="item.icon" v-if="item.icon" />
						</div>
					</div>
					<div class="resource-list__item-content">
						<h3 class="resource-list__item-title">{{ item.name }}</h3>
						<p class="resource-list__item-body" v-html="item.description"></p>
					</div>
				</div>
			</div>

			<!-- <div class="message">
				<div class="message__body">
					<h4 class="message__title">How Banks Join</h4>
					<p class="message__content">lorem ipsum</p>
				</div>
			</div> -->

			<div class="message success" v-if="message">
				<div class="message__body">
					<p class="message__content" v-html="message"></p>
				</div>
			</div>

			<hr class="hr" />

			<div class="modal-alist__actions">
				<button class="button button--raised button--secondary form__action" @click.prevent.stop="requestPrompt(resource)" :disabled="isLoading">
					Request Access
				</button>
				<a class="button button--primary form__action" @click="$emit('close')">close</a>
			</div>
		</div>
	</div>
</template>

<script>
import { ResourceAccess, ResourceStatus } from '@/lib/enums'
import { invert } from 'lodash'
import AButton from '@/components/AButton.vue'

export default {
	name: 'ModalAlist',
	components: {
		AButton,
	},
	asyncData: ({ store }) => {
		return store.dispatch('resource/list')
	},
	data: () => ({
		isLoading: false,
		message: null,
	}),
	emits: ['close'],
	computed: {
		resources() {
			const resources = this.$store.getters['resource/resources']
			return resources.filter(r => r.status !== invert(ResourceStatus).Inactive && r.access === 'alist' )
		},
		resource() {
			return this.resources.find(r => r.resourceId == this.$route.params?.resourceId)
		},
	},
	methods: {
		requestPrompt(resource) {
			this.isLoading = true
			this.message = null
			this.$store.dispatch('resource/requestInfo', resource.resourceId)
				.then((res) => {
					this.message = `Thank you for the request! We will be in touch shortly.`
				})
				.catch((error) => {
					this.$notice(`ERROR: ${error.message || error}`)
					this.isLoading = false
				})
				.finally(() => {
				})
			// this.$confirm(`Would you like to request access to our A-List Resources?`, () => {
			// }, {
			// 	title: `Request Access`,
			// 	acceptLabel: `Yes, Send Request`,
			// })
		},
	},
}
</script>

<style scoped lang="scss">
.modal-alist {

	&__header {
		background-color: modules.color_('primary');
		@include modules.gutter('padding');
		color: modules.color_('primary','text');
		text-align: center;
		display: flex;
		flex-direction: column;
		gap: 0.75rem;
	}

	&__title {
		margin: 0;
	}

	&__description {
		margin: 0;
	}

	&__tag {
		color: modules.color_('secondary');
		font-style: italic;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		gap: 0.35rem;
		margin: 0;

		&:before,
		&:after {
			content: '';
			display: block;
			height: 1px;
			width: 1.5rem;
			background-color: modules.color_('secondary');
		}
	}

	&__actions {
		@include modules.gutter('padding-bottom', 0.5);
		// @include modules.gutter('padding-top');
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	.message {
		@include modules.gutter('margin-bottom');
		@include modules.gutter('margin-top');
	}
}

.resource-list {
	display: flex;
	flex-direction: column;
	gap: 1rem;

	&__item {
		display: flex;
		flex-direction: row;
		gap: 1rem;

		&-logo {
			background-color: modules.color_('primary');
			border-radius: 0.5rem;
			padding: 0.75rem;
			display: flex;
			align-items: center;

			ion-icon {
				color: modules.color_('secondary');
				@include modules.fontSize(30px);
			}

			img {
				color: modules.color_('secondary');
				height: 30px;
				width: 30px;
			}
		}

		&-content {
			display: flex;
			flex-direction: column;
			gap: 0.25rem;
		}

		&-title {
			margin: 0;
		}

		&-body {
			margin: 0;
			padding: 0;
		}
	}
}
</style>
